import request from '@/utils/request'

// 查询知识产权pct列表
export function listPtc(query) {
  return request({
    url: '/web/zscq/ptc/list',
    method: 'get',
    params: query
  })
}